export default {
  'balanceTransactionSearchForm.header': 'Transaction Search Criteria',
  'balanceTransactionSearchForm.refineSearch': 'Refine Search',
  'balanceTransactionSearchForm.transactionDescription': 'Transaction Description',
  'balanceTransactionSearchForm.customerRefNumber': 'Customer Reference',
  'balanceTransactionSearchForm.noDataMessage': 'No transactions matched your search criteria.',
  'balanceTransactionSearchForm.showAdditionalFilters': 'Show Additional Filters',
  'balanceTransactionSearchForm.hideAdditionalFilters': 'Hide Additional Filters',
  'balanceTransactionSearchForm.transactionType': 'Transaction Type',
  'balanceTransactionSearchForm.invalidRange': 'Invalid Range',
  'balanceTransactionSearchForm.error': 'Something went wrong',
  'balanceTransactionSearchForm.reportCriteriaName': 'report criteria name',
  'balanceTransactionSearchForm.maxRangeError': 'Max Date Range is <%=count %>'
};
